import { defineComponent as o, openBlock as e, createBlock as i, unref as a, withCtx as c, createElementVNode as l, createCommentVNode as m, createVNode as d, resolveDynamicComponent as r, createTextVNode as h, toDisplayString as n, createElementBlock as s } from "vue";
import { RevButtonCard as g } from "@ds/components/ButtonCard";
import { RevIllustration as u } from "@ds/components/Illustration";
import { RevIllustrationSource as f } from "@ds/components/IllustrationSource";
const x = { class: "flex h-full flex-col items-center justify-start p-16 md:p-24 md:pt-32" }, k = { class: "mx-auto mb-32 flex max-h-full min-h-0 w-full max-w-320 justify-center sm:mb-12 md:mb-24" }, b = { class: "self-stretch text-center md:text-left" }, w = {
  key: 0,
  class: "text-static-default-low body-2 hidden md:mt-4 md:block"
}, R = /* @__PURE__ */ o({
  name: "RevCategoryCard",
  __name: "CategoryCard",
  props: {
    title: {},
    description: {},
    image: {},
    link: {},
    titleTag: { default: "h2" },
    tracking: {}
  },
  setup(t) {
    return (y, C) => (e(), i(a(g), {
      class: "inline-block min-h-[13rem] w-full sm:min-h-[13.5rem]",
      to: t.link,
      tracking: t.tracking
    }, {
      default: c(() => [
        l("div", x, [
          l("picture", k, [
            t.image.srcMobile ? (e(), i(a(f), {
              key: 0,
              height: t.image.heightMobile || t.image.height,
              media: "(max-width: 480px)",
              src: t.image.srcMobile,
              width: t.image.widthMobile || t.image.width
            }, null, 8, ["height", "src", "width"])) : m("", !0),
            d(a(u), {
              alt: t.image.alt,
              class: "block object-contain",
              height: t.image.height,
              src: t.image.src,
              width: t.image.width
            }, null, 8, ["alt", "height", "src", "width"])
          ]),
          l("div", b, [
            (e(), i(r(t.titleTag), { class: "text-static-default-hi body-1" }, {
              default: c(() => [
                h(n(t.title), 1)
              ]),
              _: 1
            })),
            t.description ? (e(), s("span", w, n(t.description), 1)) : m("", !0)
          ])
        ])
      ]),
      _: 1
    }, 8, ["to", "tracking"]));
  }
});
export {
  R as default
};
